"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_1 = require("@sentry/browser");
/**
 * A Sentry middleware for zustand that will store the latest state in Sentry's context.
 */
const baseSentryMiddleware = (config, sentryConfig) => (set, get, api) => config((...args) => {
    set(...args);
    const newState = get();
    (0, browser_1.configureScope)((scope) => {
        if (newState) {
            const transformedState = (sentryConfig === null || sentryConfig === void 0 ? void 0 : sentryConfig.stateTransformer)
                ? sentryConfig.stateTransformer(newState)
                : newState;
            scope.setContext('state', {
                state: {
                    type: 'zustand',
                    value: transformedState,
                },
            });
        }
        else {
            scope.setContext('state', null);
        }
    });
}, get, api);
/**
 * A Sentry middleware for zustand that will store the latest state in Sentry's context.
 */
const sentryMiddleware = baseSentryMiddleware;
exports.default = sentryMiddleware;
